import {useContext} from 'react'
import {ItemBagContext} from '../../../context/ItemBagContext.jsx'

import {Fab} from '@mui/material'
import {LocalPizzaRounded as LocalPizzaIcon} from '@mui/icons-material'

import './floatingButton.scss'

const FloatingButton = ({onClick}) => {
    const {flavorItems} = useContext(ItemBagContext)
    return <div className={'floating-button-item-bag'}>
        {(!!flavorItems.length) && <Fab
            color={'secondary'}
            onClick={() => onClick()}>
            <LocalPizzaIcon className={'icon'}/>
        </Fab>}
    </div>
}

export default FloatingButton
